module.exports = __webpack_public_path__ + "img/aguacate.f55090ce.jpg";